import { AfterContentInit, ChangeDetectorRef, DoCheck, ElementRef, EventEmitter, isDevMode, OnDestroy, OnInit, QueryList, } from '@angular/core';
import { FormControl, FormGroupDirective, NgControl, NgForm, } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import isArray from 'lodash-es/isArray';
import isEqual from 'lodash-es/isEqual';
import { BehaviorSubject, merge, Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UiSelectCardComponent, } from './ui-select-card/ui-select-card.component';
var UiSelectCardGroupComponent = /** @class */ (function () {
    function UiSelectCardGroupComponent(_elementRef, _errorStateMatcher, _parentForm, _parentFormGroup, ngControl, _cd) {
        this._elementRef = _elementRef;
        this._errorStateMatcher = _errorStateMatcher;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        this.ngControl = ngControl;
        this._cd = _cd;
        this.clearable = false;
        /**
         * @ignore
         */
        this.isDevMode = isDevMode();
        /**
         * @ignore
         */
        this.errorState = false;
        /**
         * @ignore
         */
        this.focused = false;
        /**
        * @ignore
        */
        this.id = "ui-select-card-group-" + Math.random();
        /**
         * @ignore
         */
        this.describedBy = '';
        /**
         * Emits the selected item value an item is selected.
         *
         */
        this.selected = new EventEmitter();
        /**
         * The component loading state source.
         *
         * @ignore
         */
        this.loading$ = new BehaviorSubject(false);
        /**
         * @ignore
         */
        this.inputControl = new FormControl('');
        /**
        * @ignore
        */
        this.stateChanges = new Subject();
        this._multiple = false;
        this._required = false;
        this._placeholder = '';
        this._readonly = false;
        this._disabled = false;
        this._destroyed$ = new Subject();
        /**
         * @ignore
         */
        this.registerChange = function (_) { };
        /**
         * @ignore
         */
        this.registerTouch = function (_) { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "required", {
        /**
         * Configure if the input should be marked as `required` inside the form field.
         *
         */
        get: function () {
            return this._required;
        },
        /**
         * @ignore
         */
        set: function (required) {
            required = !!required || this._elementRef.nativeElement.hasAttribute('required');
            if (this._required !== required) {
                this._required = required;
                this.stateChanges.next();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "shouldLabelFloat", {
        /**
         * Configure if the form control label should float.
         *
         */
        get: function () {
            return this.focused || !this.empty;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "empty", {
        /**
         * Returns `true` if there are no items available.
         *
         */
        get: function () {
            return !this._value || !this._value.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "placeholder", {
        /**
         * Configure the component placeholder.
         *
         */
        get: function () {
            return this._placeholder;
        },
        set: function (placeholder) {
            this._placeholder = placeholder;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "readonly", {
        /**
         * Configure if the component is `readonly`.
         *
         */
        get: function () {
            return this._readonly;
        },
        set: function (value) {
            this._readonly = !!value;
            this.stateChanges.next();
            this._cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "disabled", {
        /**
         * Configure if the component is `disabled`.
         *
         */
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            this._disabled = !!value;
            this.stateChanges.next();
            this._cd.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "loading", {
        /**
         * Configure if the dropdown is in a `loading` state.
         *
         */
        set: function (value) {
            this.loading$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "value", {
        /**
         * Handles the dropdown value binding.
         *
         */
        get: function () {
            return this._value;
        },
        /**
         * @ignore
         */
        set: function (newValue) {
            var normalizedValue = this.multiple && !isArray(newValue) ?
                [newValue] :
                newValue;
            this._value = normalizedValue;
            this._updateSelection();
            this.stateChanges.next();
            this.registerChange(normalizedValue);
            this.selected.emit(normalizedValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardGroupComponent.prototype, "multiple", {
        /**
         * Enable multiple selection
         *
         */
        get: function () { return this._multiple; },
        set: function (multiple) {
            if (multiple === this._multiple) {
                return;
            }
            this._multiple = multiple;
            if (multiple && !isArray(this._value)) {
                this._value = this._value ?
                    [this._value] :
                    [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.ngDoCheck = function () {
        if (!this.ngControl) {
            return;
        }
        var oldState = this.errorState;
        var control = this.ngControl ?
            this.ngControl.control :
            null;
        var parent = this._parentFormGroup || this._parentForm;
        var newState = this._errorStateMatcher.isErrorState(control, parent);
        if (newState !== oldState) {
            this.errorState = newState;
            this.stateChanges.next();
        }
    };
    /**
     * Sets the select's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param value New value to be written to the model.
     */
    UiSelectCardGroupComponent.prototype.writeValue = function (value) {
        if (isEqual(value, this._value)) {
            return;
        }
        this.value = value;
        this._cd.markForCheck();
    };
    /**
     * Handles `click` events on the `form-control` container.
     *
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.onContainerClick = function (_) { };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.ngOnInit = function () {
    };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._updateSelection();
        this.stateChanges.next();
        merge.apply(void 0, this.cards.map(function (card) { return card.toggleSelect$; })).pipe(takeUntil(this._destroyed$)).subscribe(function (_a) {
            var select = _a.select, value = _a.value;
            if (select) {
                _this.select(value);
            }
            else {
                _this.deselect(value);
            }
        });
    };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.registerOnChange = function (fn) {
        this.registerChange = fn;
    };
    /**
     * @ignore
     */
    UiSelectCardGroupComponent.prototype.registerOnTouched = function (fn) {
        this.registerTouch = fn;
    };
    UiSelectCardGroupComponent.prototype.select = function (newValue) {
        if (this._disabled || this._readonly) {
            return;
        }
        this.value = this.multiple ? (isArray(this.value) ?
            this.value :
            [this.value]).concat([
            newValue,
        ]) :
            newValue;
    };
    UiSelectCardGroupComponent.prototype.deselect = function (oldValue) {
        if (this._disabled ||
            this._readonly ||
            !this.multiple) {
            return;
        }
        if (this.multiple) {
            this.value = this.value
                .filter(function (option) { return option !== oldValue; });
            return;
        }
        if (this.clearable && isEqual(oldValue, this.value)) {
            this.value = undefined;
        }
    };
    UiSelectCardGroupComponent.prototype._updateSelection = function () {
        var _this = this;
        if (!this.cards) {
            return;
        }
        this.cards
            .forEach(function (option) {
            option.selected = _this.multiple ?
                !!(_this._value || []).find(function (selected) { return isEqual(selected, option.value); }) :
                isEqual(_this._value, option.value);
        });
    };
    return UiSelectCardGroupComponent;
}());
export { UiSelectCardGroupComponent };
